export const CUSTOM_SOLAR_PANEL_MANUFACTURER = 0;
